import styled from 'styled-components';

export const MapInfoWindowTitle = styled.span`
  display: block;
  margin-bottom: 6px;
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 16px;
`;

export const MapInfoWindowText = styled.span`
  display: block;
  line-height: 18px;
  font-size: 13px;
`;

export const MapInfoWindowContent = styled.div``;
